<!--
/**
 * peacohrm is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 peacohrm Inc., http://www.peacohrm.com
 *
 * peacohrm is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * peacohrm is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */
 -->

<template>
  <div class="peacohrm-background-container">
    <div class="peacohrm-card-container">
      <oxd-text tag="h6" class="peacohrm-main-title">
        {{ $t('admin.module_configuration') }}
      </oxd-text>

      <oxd-divider />

      <oxd-form :loading="isLoading" @submit-valid="onSave">
        <oxd-form-row>
          <oxd-grid :cols="3" class="peacohrm-full-width-grid">
            <div class="peacohrm-module-field-row">
              <oxd-text tag="p" class="peacohrm-module-field-label">
                <!-- {{ $t('admin.admin_module') }} -->
                Super User Module
              </oxd-text>
              <oxd-switch-input v-model="modules.admin" :disabled="true" />
            </div>
            <div class="peacohrm-module-field-row">
              <oxd-text tag="p" class="peacohrm-module-field-label">
                <!-- {{ $t('admin.pim_module') }} -->
                Personal Data Organizer Module
              </oxd-text>
              <oxd-switch-input v-model="modules.personal_data" :disabled="true" />
            </div>
            <div class="peacohrm-module-field-row">
              <oxd-text tag="p" class="peacohrm-module-field-label">
                <!-- {{ $t('admin.leave_module') }} -->
                Leave Management Module
              </oxd-text>
              <oxd-switch-input v-model="modules.leave" />
            </div>
            <div class="peacohrm-module-field-row">
              <oxd-text tag="p" class="peacohrm-module-field-label">
                <!-- {{ $t('admin.time_module') }} -->
                Time Sheets Module
              </oxd-text>
              <oxd-switch-input v-model="modules.time" />
            </div>
            <div class="peacohrm-module-field-row">
              <oxd-text tag="p" class="peacohrm-module-field-label">
                <!-- {{ $t('admin.recruitment_module') }} -->
                Talent Acquisition Module
              </oxd-text>
              <oxd-switch-input v-model="modules.acquisition" />
            </div>
            <div class="peacohrm-module-field-row">
              <oxd-text tag="p" class="peacohrm-module-field-label">
                <!-- {{ $t('admin.performance_module') }} -->
                Performance Appraisal Module
              </oxd-text>
              <oxd-switch-input v-model="modules.performance" />
            </div>
            <div class="peacohrm-module-field-row">
              <oxd-text tag="p" class="peacohrm-module-field-label">
                <!-- {{ $t('admin.directory_module') }} -->
                Search Module
              </oxd-text>
              <oxd-switch-input v-model="modules.search" />
            </div>
            <div class="peacohrm-module-field-row">
              <oxd-text tag="p" class="peacohrm-module-field-label">
                {{ $t('admin.maintenance_module') }}
              </oxd-text>
              <oxd-switch-input v-model="modules.maintenance" />
            </div>
            <div class="peacohrm-module-field-row">
              <oxd-text tag="p" class="peacohrm-module-field-label">
                {{ $t('general.mobile') }}
              </oxd-text>
              <oxd-switch-input v-model="modules.mobile" />
            </div>
            <div class="peacohrm-module-field-row">
              <oxd-text tag="p" class="peacohrm-module-field-label">
                <!-- {{ $t('reimbursement.claim_module') }}  -->
                Reimbursement Module
              </oxd-text>
              <oxd-switch-input v-model="modules.reimbursement" />
            </div>
          </oxd-grid>
        </oxd-form-row>

        <oxd-divider />

        <oxd-form-actions>
          <submit-button />
        </oxd-form-actions>
      </oxd-form>
    </div>
  </div>
</template>

<script>
import {APIService} from '@/core/util/services/api.service';
import {reloadPage} from '@/core/util/helper/navigation';
import {OxdSwitchInput} from '@ohrm/oxd';

const modulesModel = {
  admin: false,
  personal_data: false,
  leave: false,
  time: false,
  acquisition: false,
  performance: false,
  maintenance: false,
  mobile: false,
  search: false,
  reimbursement: false,
};

export default {
  components: {
    'oxd-switch-input': OxdSwitchInput,
  },
  setup() {
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/super_user/modules',
    );
    return {
      http,
    };
  },
  data() {
    return {
      modules: {...modulesModel},
      isLoading: false,
    };
  },
  created() {
    this.isLoading = true;
    this.http
      .getAll()
      .then((response) => {
        const {data} = response.data;
        this.modules.admin = data.admin;
        this.modules.personal_data = data.personal_data;
        this.modules.leave = data.leave;
        this.modules.time = data.time;
        this.modules.acquisition = data.acquisition;
        this.modules.performance = data.performance;
        this.modules.maintenance = data.maintenance;
        this.modules.mobile = data.mobile;
        this.modules.search = data.search;
        this.modules.reimbursement = data.reimbursement;
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
  methods: {
    onSave() {
      this.isLoading = true;
      const payload = {
        admin: true,
        personal_data: true,
        leave: this.modules.leave,
        time: this.modules.time,
        acquisition: this.modules.acquisition,
        performance: this.modules.performance,
        maintenance: this.modules.maintenance,
        mobile: this.modules.mobile,
        search: this.modules.search,
        reimbursement: this.modules.reimbursement,
      };
      this.http
        .request({
          method: 'PUT',
          data: payload,
        })
        .then((response) => {
          const {data} = response.data;
          this.modules = data;
          return this.$toast.saveSuccess();
        })
        .finally(() => {
          this.isLoading = false;
          reloadPage();
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.peacohrm-module-field-row {
  grid-column-start: 1;
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 0.75rem;
}
.peacohrm-module-field-label {
  @include oxd-input-control();
  padding: 0;
  flex-basis: 75%;
}
</style>
